import {InjectionToken} from '@angular/core';
import {CoreConfig} from "../core/core-config.model";

export const UR_CORE_CONFIG = new InjectionToken<CoreConfig>('Core config');
